import shortid from 'shortid';
import EmailCredentialModel from '@/common/models/email-credential-model';

export default {
    props: {
        email: Object,
        /**
         * @type {ValidationAggregator|{}}
         */
        validationAggregator: Object,
        activeType: String,
        type: String,
    },
    computed: {
        uniqueId() {
            return shortid.generate();
        },
        /**
         * Defines whether the current credential is the one active (visible in tab)
         * @returns {boolean}
         */
        isActiveType() {
            return this.type === this.activeType;
        },
    },
    watch: {
        cred: {
            deep: true,
            handler(cred) {
                if (this.isActiveType) {
                    this.$emit('input', cred);
                }
            },
        },
    },
    data() {
        return {
            cred: this.credentials().cloneSelf(),
        };
    },
    methods: {
        getValidationAggregate() {
            return false;
        },
        credentials() {
            let definition = {
                type: this.type,
            };
            if (this.email.$credentials && this.email.$credentials.type === this.type) {
                definition = {
                    type: this.type,
                    ...this.email.$credentials.getPayload(),
                };
            }
            return new EmailCredentialModel(definition);
        },
    },
    created() {
        const aggregate = this.getValidationAggregate();
        if (this.validationAggregator && aggregate) {
            // append unique ID to differentiate multiple instances of the
            // same action
            aggregate.name = `${aggregate.name}_${this.uniqueId}`;
            this.aggregateName = aggregate.name;
            this.validationAggregator.registerComponent(aggregate);
        }
    },
    beforeDestroy() {
        if (this.validationAggregator) {
            this.validationAggregator.deregisterComponent(this.aggregateName);
        }
    },
};
